<template>
    <df-app>
        <div class="user-profile">
            <div class="row">
                <div class="col-lg-5">
                    <df-coach :data="source"/>
                </div>
                <div class="col-lg-7">
                    <be-loading :active="submitting">
                        <form @submit.prevent="submit">
                            <be-card header-color="primary" footer-contrast title="Profil bearbeiten">
                                <image-upload
                                    ref="avatar"
                                    label="Avatar"
                                    :width="150"
                                    :height="150"
                                    :value="data.avatarBig"
                                    @input="v => data.avatar = v"
                                />
                                <text-field label="Vorname" v-model="data.firstname" :validation="$v.data.firstname"/>
                                <text-field label="Nachname" v-model="data.lastname" :validation="$v.data.lastname"/>
                                <text-field label="E-Mail Adresse" v-model="data.email" :validation="$v.data.email" disabled/>

                                <hr>
                                <image-upload
                                    ref="background"
                                    label="Header-Bild"
                                    :width="426"
                                    :height="121"
                                    :value="data.backgroundPath"
                                    @input="v => data.background = v"
                                />
                                <text-field label="Region" v-model="data.region" :validation="$v.data.region"/>
                                <tag-list label="Spezialisierung" :options="specializationOptions" v-model="data.specialization" :validation="$v.data.specialization"/>
                                <radio-checkbox multiple inline name="language" label="Sprachen" :options="languageOptions" v-model="data.languages" :validation="$v.data.languages"/>

                                <hr>
                                <image-upload
                                    ref="logo"
                                    whitespace
                                    label="Logo"
                                    :width="155"
                                    :height="54"
                                    :value="data.companyLogoPath"
                                    @input="v => data.companyLogo = v"
                                />
                                <text-field label="Firma" v-model="data.company" :validation="$v.data.company"/>
                                <text-field label="Strasse" v-model="data.companyStreet" :validation="$v.data.companyStreet"/>
                                <text-field label="PLZ" v-model="data.companyPostcode" :validation="$v.data.companyPostcode"/>
                                <text-field label="Ort" v-model="data.companyLocation" :validation="$v.data.companyLocation"/>
                                <select-menu label="Land" :options="countries" v-model="data.companyCountry" :validation="$v.data.companyCountry"/>
                                <text-field label="Telefon" v-model="data.companyPhone" :validation="$v.data.companyPhone"/>
                                <text-field label="Website" v-model="data.companyWebsite" :validation="$v.data.companyWebsite"/>

                                <div class="text-right" slot="footer">
                                    <submit-button h-space>Änderungen speichern</submit-button>
                                    <submit-button type="button" color="secondary" @click="reset">Zurücksetzen</submit-button>
                                </div>
                            </be-card>
                        </form>
                    </be-loading>
                </div>
            </div>
        </div>
    </df-app>
</template>

<script>
    import { mapGetters } from 'vuex';
    import userForm from '../../../mixins/user-form';
    import errorHandler from '../../../mixins/errorHandler';
    import User from '../../../models/User';

    export default {
        mixins: [userForm, errorHandler],

        data: () => ({
            data: {},
            submitting: false,
        }),

        computed: {
            ...mapGetters('user', { source: 'user' }),
        },

        methods: {
            async submit() {
                this.$v.$reset();
                this.$v.$touch();

                if (this.$v.$pending || this.$v.$error) {
                    this.$nextTick(() => {
                        this.$scrollTo('.parsley-errors-list', 500, {
                            offset: -200,
                        });
                    });

                    return;
                }

                this.submitting = true;

                try {
                    await Promise.all([
                        this.$refs.avatar.upload(),
                        this.$refs.background.upload(),
                        this.$refs.logo.upload(),
                    ]);

                    const data = await this.data.save();

                    this.$store.commit('user/setProfile', Object.assign({}, data));

                    this.$store.dispatch('notifications/add', {
                        color: 'success',
                        title: 'Gespeichert!',
                        description: 'Die Daten wurden erfolgreich gespeichert.',
                    });
                } catch (err) {
                    this.catchError(
                        'Fehler beim Speichern',
                        'Die Daten konnten nicht gespeichert werden.',
                        err,
                    );
                } finally {
                    this.submitting = false;
                    this.$v.$reset();
                }
            },

            reset() {
                this.data = new User(this.source);

                if (this.$refs.avatar) this.$refs.avatar.refresh();
                if (this.$refs.background) this.$refs.background.refresh();
                if (this.$refs.logo) this.$refs.logo.refresh();
            },
        },

        watch: {
            profile() {
                this.reset();
            },
        },

        created() {
            this.reset();
        },
    };
</script>
